import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import SonXProductsSection from '../Components/MyProducts/Section1';
import ProductGrid from '../Components/MyProducts/Section2';
import Footer from '../Components/Footer';
import Loader from '../Components/Loader/Loader'; // Import the loader component
import { WhatsApp } from "@mui/icons-material"; // Import WhatsApp icon
import { IconButton } from "@mui/material";
import Header2 from '../Components/Header2';


function MyProducts() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay, e.g., fetching data or waiting for an API response
    setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds (replace with real async operations)
    }, 2000);
  }, []);

  if (isLoading) {
    return <Loader />; // Show loader while loading
  }

  return (
    <div>
      <Header2 />
      <div style={{ marginTop: '90px' }}>
        <SonXProductsSection />
      </div>
      <div>
        <ProductGrid />
      </div>
      <Footer />
       {/* WhatsApp icon at the bottom-right */}
       <IconButton
            href="https://wa.me/+971524346217"
            target="_blank"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#25D366",
              borderRadius: "50%",
              padding: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <WhatsApp style={{ color: "#fff", fontSize: "35px" }} />
          </IconButton>
    </div>
  );
}

export default MyProducts;
